import React, { useEffect, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useFetchScaleReadingRouteSessionCandidates } from '../../../../../data/generic-queries/scale-readings';
import Select from '../../../../../configured-components/form/configured-inputs/select/Select';

const NO_CANDIDATES = [];

const ScaleReadingRouteSessionSelect = ({ name, dateRange, currentlyLinkedId, props: renderProps = {}, ...rest }) => {
    const { setValue, clearErrors } = useFormContext();
    const processorId = useWatch({ name: 'processor_id' });
    const processorIdValue = processorId?._id ?? processorId;

    // Clear any selected route_session_id when the processor changes — the previous
    // selection belonged to a different processor and submitting it would either
    // bind a mismatched RS or fail the backend's processor-scoped lookup.
    //
    // Important: do NOT trigger validation on the clear. The field is required, so a
    // null value fires an "is required" error immediately, which looks like the form
    // is broken before the user has even had a chance to pick a new value. Let the
    // existing form mode pick up the missing value on the next submit/blur instead.
    const previousProcessorIdRef = useRef(processorIdValue);
    useEffect(() => {
        if (previousProcessorIdRef.current !== processorIdValue) {
            if (previousProcessorIdRef.current !== undefined) {
                setValue(name, null, { shouldDirty: true, shouldValidate: false });
                clearErrors(name);
            }
            previousProcessorIdRef.current = processorIdValue;
        }
    }, [processorIdValue, name, setValue, clearErrors]);

    const { data, isLoading } = useFetchScaleReadingRouteSessionCandidates({
        dateRange,
        currentlyLinkedId,
        processorId: processorIdValue,
    });
    const candidates = data ?? NO_CANDIDATES;

    return (
        <Select
            name={name}
            loading={isLoading}
            props={{
                label: renderProps.label,
                required: renderProps.required,
                options: candidates,
                optionLabel: { keys: ['BOL'] },
            }}
            {...rest}
        />
    );
};

export default ScaleReadingRouteSessionSelect;
